import { Link } from 'react-router-dom'
import DocLayout from '../components/docs/DocLayout'
import SourceLinks from '../components/docs/SourceLinks'
import { OPERATOR } from '../content/provenance'
import Cased from '@/components/ui/Cased'

export default function AboutPage() {
  return (
    <DocLayout
      eyebrow="About MDS"
      title="Design for America."
      intro="Mission Design System is the design system for United States government websites: foundations, components, patterns and a theme for every agency, built by MetaPhase."
    >
      <section className="doc-section">
        <h2><Cased>One system, every mission</Cased></h2>
        <p>
          MDS carries the visual language of the National Design Studio era of
          federal sites into a system any team can adopt: a display serif, a
          precise sans, red, white and blue, generous rounded surfaces and a
          centered official banner. Light and dark themes come standard.
        </p>
        <p>
          Each agency gets a mission theme generated from its own colors and
          seal. Every theme is checked for contrast in both modes and published
          as plain CSS and JSON.
        </p>
      </section>
      <section className="doc-section">
        <h2><Cased>Built for people and agents</Cased></h2>
        <p>
          The documentation and the machine-readable resources share typed
          definitions. A token, component, pattern or rule can be read by a
          designer, implemented by an engineer and used by a coding agent.
        </p>
        <p>
          <Link to="/agents">Explore the agent toolkit</Link>
        </p>
      </section>
      <section className="doc-section">
        <h2><Cased>Built by MetaPhase</Cased></h2>
        <p>
          Mission Design System is built and operated by{' '}
          <a href={OPERATOR.url}>MetaPhase</a> as part of MPworks, the MetaPhase
          modernization factory. ChallengeAI is the accelerator applied during
          engineering.
        </p>
      </section>
      <section className="doc-section">
        <h2><Cased>Grounded in established guidance</Cased></h2>
        <p>
          MDS draws on USWDS interaction conventions, W3C accessibility guidance
          and federal plain language practices, and maps each component to its
          USWDS equivalent so teams can migrate gradually.
        </p>
        <p>
          <Link to="/accessibility">Read the accessibility approach</Link>
        </p>
      </section>
      <section className="doc-section">
        <h2><Cased>Credits</Cased></h2>
        <p>
          MDS builds on the National Design Studio and the U.S. Web Design
          System, and uses photographs, seals and typefaces made by others.
        </p>
        <p>
          <Link to="/credits">See the credits</Link>
        </p>
      </section>
      <section className="doc-section">
        <h2><Cased>Source and licensing</Cased></h2>
        <p>
          The MDS source and branded assets are governed by the{' '}
          <Link to="/license">Protoware License</Link>. Every typeface comes
          from Google Fonts under an open license and is served from
          this site; see{' '}
          <Link to="/foundations/typography">Typography</Link>.
        </p>
      </section>
      <SourceLinks ids={['uswds', 'accessibility', 'plainLanguage', 'nds']} />
    </DocLayout>
  )
}
